<template>
  <div class="pronostic">
    <b-card
      footer-tag="footer"
      :img-src="'/img/'+prognostic.type+'.jpg'"
      :img-alt="prognostic.type"
      img-top
      tag="article"
      class="button"
      bg-variant="dark"
      text-variant="white"
      v-on:click="prognostic.id ? $router.push('/pronostic/'+prognostic.id) : $router.push('/abonnement')"
      style="height: 30rem;"
    >
      <div class="float-right">
        <b-badge pill variant="warning" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.date >= vip_timestamp">Pronostic VIP</b-badge>
        <b-badge pill variant="secondary" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.type && prognostic.type != 'vip'">{{ prognostic.type.toUpperCase() }}</b-badge>
        <b-badge pill variant="success" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.win === true">GAGNANT</b-badge>
        <b-badge pill variant="danger" class="d-block" style="margin-bottom: 2px;" v-if="prognostic.win === false">PERDANT</b-badge>
      </div>
      <b-card-title class="text-uppercase text-warning">
        <h6>{{ prognostic.title + (prognostic.cote ? ' - COTE à ' + prognostic.cote : '') }}</h6>
      </b-card-title>
      <b-card-sub-title class="text-muted font-italic">
        <small>du {{ moment(prognostic.date).format('dddd Do MMMM YYYY') }}</small>
      </b-card-sub-title>
      <b-card-text style="margin-top: 1em;" v-if="prognostic.text" v-html="prognostic.text.split('\n').join('<br/>')"></b-card-text>
      <small slot="footer" class="text-muted" v-if="prognostic.details" v-html="prognostic.details.split('\n').join('<br/>')"></small>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['prognostic'],
  data: () => ({ vip_timestamp: moment().startOf('day').unix() }),
  methods: {
    moment(ts) { return ts ? moment.unix(ts) : moment() }
  }
}
</script>
